import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { PageInfoService, PageLink } from '@metronic/layout';
import { IDetailProduct, IProductDesc, QrDataGenerator } from '../Products.interface';
import { UtilitiesService } from '@services/utilities.service';
import { BaseService } from '@services/base-service.service';
import { API } from '@config/constants/api.constant';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalConfig } from '@shared/components/modal/modal.interface';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { RolePrivilegeService } from '@services/role-privilege.service';

@Component({
  selector: 'app-detail-products',
  templateUrl: './detail-products.component.html',
  styleUrls: ['./detail-products.component.scss'],
})
export class DetailProductsComponent implements OnInit {
  @ViewChild('printQrcode') printQrcodes: ElementRef<HTMLElement>;
  public config = {
    htmlType: 'domObj',
    printMode: 'template-popup',
    popupProperties: 'toolbar=yes,scrollbars=yes,resizable=yes,top=0,left=0,fullscreen=yes',
    stylesheets: [{ rel: 'stylesheet', href: './document-test/document-test.component.scss' }],
  };
  STRING_CONSTANTS = STRING_CONSTANTS;
  iconSuccess = STRING_CONSTANTS.ICON.SUCCESS_ALERT;
  productId: string;
  links: Array<PageLink>;
  formGroup: FormGroup;
  valueSetQr: string;
  detailProduct: BehaviorSubject<IDetailProduct | undefined> = new BehaviorSubject<IDetailProduct | undefined>(undefined);
  onLoadingGenerateQr: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  productDescription: BehaviorSubject<IProductDesc> = new BehaviorSubject<IProductDesc>({
    product_usage: '',
    description: '',
  });
  listGenerateProduct: BehaviorSubject<QrDataGenerator[] | undefined> = new BehaviorSubject<QrDataGenerator[] | undefined>(undefined);
  parentMenu: string = 'PRODUCT_CATALOG';
  privilegeGenerateQRCode: boolean = false;
  privilegeEditProduct: boolean = false;
  privilegeUnpublishedProduct: boolean = false;
  privilegeGenerateCSV: boolean = false;
  privilegeValidateQR: boolean = false;
  privilegeTabs: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  keyDetailPrivilege: string = 'DETAIL_PRODUCT';
  keyProductPrivilege: string = 'LIST_PRODUCT_PUBLISHED';
  tabIndex: number = 0;
  modalConfig: ModalConfig = {
    modalTitle: 'GENERATE QR CODE',
    closeButtonLabel: 'Close',
    dismissButtonLabel: 'Generate',
    disableDismissButton: () => this.formGroup.invalid,
  };
  modalConfigLoading: ModalConfig = {
    showHeader: false,
    showFooter: false,
  };
  modalConfigSubmit: ModalConfig = {
    modalTitle: 'GENERATE QR CODE',
    closeButtonLabel: 'Close',
    dismissButtonLabel: 'Lanjutkan',
  };
  modalConfigAfterGenereteCode: ModalConfig = {
    dismissButtonLabel: 'Download PDF',
    hideCloseButton(): boolean {
      return true;
    },
  };
  displayTabs: Array<any> = ['TAB_PRODUCT_INFORMATION', 'TAB_DISTRIBUTOR_EXCLUSIVE', 'TAB_VARIANT_INFORMATION', 'TAB_HISTORY_QRCODE']; /* all display tabs on this page */

  @ViewChild('modalConfirm') private modalConfirmComponent: ModalComponent;
  @ViewChild('modalConfirmSubmit') private modalConfirmSubmit: ModalComponent;
  @ViewChild('modalLoading') private modalLoading: ModalComponent;
  @ViewChild('modalAfterGenereteCode') private modalAfterGenereteCode: ModalComponent;

  // temp.disable render view; to be removed
  renderView: false;

  constructor(
    private formBuilder: FormBuilder,
    private baseService: BaseService,
    private pageInfoService: PageInfoService,
    private activatedRoute: ActivatedRoute,
    public utilitiesService: UtilitiesService,
    private router: Router,
    private rolePrivilegeService: RolePrivilegeService
  ) {}

  ngOnInit(): void {
    this.productId = this.activatedRoute.snapshot.params.id;
    this.handlePrivilege();
    this.initPageInfo();
    this.formGroup = this.formBuilder.group({
      amount_qr_input: [
        {
          value: '',
          disabled: false,
        },
        [Validators.required, Validators.min(1), Validators.max(100000)],
      ],
    });
  }

  handlePrivilege() {
    this.privilegeEditProduct = this.rolePrivilegeService.checkPrivilege(this.parentMenu, this.keyProductPrivilege, this.keyDetailPrivilege, 'CTA_EDIT');
    this.privilegeGenerateQRCode = this.rolePrivilegeService.checkPrivilege(this.parentMenu, this.keyProductPrivilege, this.keyDetailPrivilege, 'CTA_GENERATE_QR');
    this.privilegeUnpublishedProduct = this.rolePrivilegeService.checkPrivilege(this.parentMenu, this.keyProductPrivilege, this.keyDetailPrivilege, 'CTA_UNPUBLISH');
    this.privilegeGenerateCSV = this.rolePrivilegeService.checkPrivilege(this.parentMenu, this.keyProductPrivilege, this.keyDetailPrivilege, 'CTA_GENERATE_CSV_QR');
    this.privilegeValidateQR = this.rolePrivilegeService.checkPrivilege(this.parentMenu, this.keyProductPrivilege, this.keyDetailPrivilege, 'CTA_VALIDATE_QR');
    this.handlePrivilegeTab();
  }

  handlePrivilegeTab() {
    const _tabs: any = [];

    this.displayTabs.map((tab) => {
      const checkTab = this.rolePrivilegeService.checkPrivilege(this.parentMenu, this.keyProductPrivilege, this.keyDetailPrivilege, tab);
      if (checkTab) {
        _tabs.push(tab);
      }
    });
    this.privilegeTabs.next(_tabs);
    return;
  }

  initPageInfo(): void {
    this.pageInfoService.updateTitle('Detail Product');
    this.detailProduct.subscribe((data) => {
      this.links = [
        {
          title: 'Product Catalog',
          path: '',
          isActive: false,
        },
        {
          title: '',
          path: '',
          isActive: false,
          isSeparator: true,
        },
        {
          title: 'Product List',
          path: 'products/list-published',
          isActive: false,
        },
        {
          title: '',
          path: '',
          isActive: false,
          isSeparator: true,
        },
        {
          title: data?.name ?? '',
          path: '',
          isActive: true,
        },
      ];
      this.pageInfoService.updateBreadcrumbs(this.links);
    });
    this.listGenerateProduct.subscribe((data) => data);
  }

  submitForm = () => {
    this.valueSetQr = this.formGroup.controls['amount_qr_input'].value;
    this.modalConfirmSubmit.open().then();
  };

  onSubmitFormCode = () => {
    this.generateProductCode(this.valueSetQr);
  };

  onClickOpenModalGenerateCode() {
    this.modalConfirmComponent.open().then();
  }

  generateProductCode(set: string) {
    this.modalLoading.open().then();
    this.onLoadingGenerateQr.next(true);
    this.baseService.getData<QrDataGenerator[]>(API.GENERATE_QR_PRODUCT + this.productId + '/' + set).subscribe((value) => {
      if (value) {
        this.formGroup.patchValue({
          amount_qr_input: 0,
        });

        this.listGenerateProduct.next(value.data);

        setTimeout(() => {
          this.modalLoading.close().then(() => this.onLoadingGenerateQr.next(false));
          this.modalAfterGenereteCode.open().then();
        }, 2000);
      }
    });
  }

  onClickEditProduct() {
    this.router.navigate(['/products/detail/edit/' + this.productId]).then();
  }

  handleProductDescription(e: IProductDesc) {
    this.productDescription.next({
      description: e.description,
      product_usage: e.product_usage,
    });
  }

  handleProductData(e: IDetailProduct) {
    if (e) {
      this.detailProduct.next(e);
    }
  }

  downloadPrint = () => {
    this.triggerPrint();
  };

  triggerPrint() {
    this.printQrcodes.nativeElement.click();
  }

  // temp. generate 1000 set
  downloadCSV(set = 1000) {
    this.baseService.getData<QrDataGenerator[]>(API.GENERATE_QR_PRODUCT + this.productId + '/' + set).subscribe((response) => {
      if (response) {
        this.utilitiesService.downloadFile<QrDataGenerator>(response.data, 'product', ['product_name', 'product_unit', 'qr_code_r1', 'qr_code_r2']);
      }
    });
  }

  onClickValidateQr() {
    this.router.navigate(['/products/detail/validate/' + this.productId]).then();
  }

  handleTabChange(e: MatTabChangeEvent) {
    const snapshot = this.activatedRoute.snapshot.queryParams;
    // remove param url on change tab
    if (Object.keys(snapshot).length > 0) {
      this.router.navigate(['.'], { relativeTo: this.activatedRoute, queryParams: {} }).then();
    }

    this.tabIndex = e.index;
  }
}
